import _defineProperty from "E:/code/jinhua-step-two/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { Component, Vue } from "vue-property-decorator";
import { ImagePreview } from "vant";
import { initScenicData, queryLineDetail } from "@/api/api";
import { iconList, initLineDetail } from "./Scenic";
import AMapLoader from "@amap/amap-jsapi-loader";
import ListModal from "./components/ListModal.vue";
import { themeColor, themeIcon } from "@/main";
let ScenicPage = class ScenicPage extends Vue {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "scenic_data", {});

    _defineProperty(this, "active_mark_type", 0);

    _defineProperty(this, "map", null);

    _defineProperty(this, "AMap", null);

    _defineProperty(this, "base_url", process.env.VUE_APP_BASE_URL);

    _defineProperty(this, "iconList", iconList);

    _defineProperty(this, "init_data", {
      lineBOS: [],
      pointBOS: [],
      pointTypeBOS: []
    });

    _defineProperty(this, "cluster_marker_list", []);

    _defineProperty(this, "cluster", null);

    _defineProperty(this, "active_marker", null);

    _defineProperty(this, "is_show_marker_detail_modal", false);

    _defineProperty(this, "class_name_list", {
      "17": "id-1",
      "16": "id-2",
      "18": "id-7",
      "20": "id-10",
      "21": "id-11",
      "19": "id-12"
    });

    _defineProperty(this, "menu_class_name", "");

    _defineProperty(this, "menu_class_name_active", "");

    _defineProperty(this, "id_1_long", "id-1-long");

    _defineProperty(this, "id_1_active_long", "id-1-active-long");

    _defineProperty(this, "start_y", 0);

    _defineProperty(this, "move_y", 0);

    _defineProperty(this, "line_detail_modal_class_name", "");

    _defineProperty(this, "is_show_line_detail_modal", false);

    _defineProperty(this, "is_show_line_scenic", false);

    _defineProperty(this, "line_detail_data", initLineDetail());

    _defineProperty(this, "line_marker", []);

    _defineProperty(this, "active_point", 0);

    _defineProperty(this, "polyline", null);

    _defineProperty(this, "is_play", false);

    _defineProperty(this, "audio_src", "");

    _defineProperty(this, "themeColor", themeColor);

    _defineProperty(this, "themeIcon", themeIcon);

    _defineProperty(this, "leLayer", null);

    _defineProperty(this, "my_position", null);

    _defineProperty(this, "get_position", 0);

    _defineProperty(this, "layer_list", {
      "17": "58082",
      "16": "58083",
      "18": "58085",
      "20": "58084",
      "21": "58081",
      "19": "58086"
    });
  }

  // 初始化地图
  async initMap() {
    this.AMap = await AMapLoader.load({
      key: "ee99ef87bf1a8cf262991ac318f9ac33",
      version: "2.0",
      plugins: ["AMap.Geolocation", "AMap.MarkerClusterer"]
    });
    this.map = new this.AMap.Map("scenic-page", {
      zoom: this.scenic_data.showZoom,
      center: [this.scenic_data.longitude, this.scenic_data.latitude],
      zooms: [this.scenic_data.minZoom, this.scenic_data.maxZoom]
    });
    this.leLayer = new this.AMap.TileLayer({
      // 图块取图地址,加了s=1就是下沙景区限制
      tileUrl: `http://tiles.worldmaipu.com/global/${this.layer_list[this.scenic_data.id]}/[z]/[x]_[y].png`,
      detectRetina: true,
      zIndex: 100
    });
    this.leLayer.setMap(this.map);
  } // marker点样式


  getMarkerDom(context, is_cluster_marker = false, count = 0) {
    var obj = {
      marker_content: "",
      active_marker_content: ""
    }; // 未激活的marker点样式

    obj.marker_content = `<div class="marker-style-normal">
            <img src='${this.base_url}${context?.data[0]?.data.markIcon}'/>
            <div style="color:${themeColor[this.scenic_data.id]}">${context?.data[0]?.data.name}</div>
          </div>`; // 被激活的dmarker点样式

    obj.active_marker_content = `<div class="marker-style-normal">
      <img src='${this.base_url}${context?.data[0]?.data.markIcon}'/>
      <div style="color: ${themeColor[this.scenic_data.id]}">${context?.data[0]?.data.name}</div>
    </div>`; // 聚合点marker样式

    if (is_cluster_marker) {
      obj.cluster_marker_content = `<div class="marker-style-normal cluster-style">
            <img src='${this.iconList[this.scenic_data.id].marker_bg}'/>
        <span style="color:${themeColor[this.scenic_data.id]}">${count}</span>
            <div style="color:${themeColor[this.scenic_data.id]}">${context.data.name}</div>
          </div>`;
    }

    return obj;
  } // 获取要通过点聚合渲染的marker点


  getClusterMarkerList() {
    this.init_data.pointBOS.filter(item => item.pointTypeId === this.init_data.pointTypeBOS[this.active_mark_type]?.id).forEach(item => {
      const obj = {
        lnglat: [item.longitude, item.latitude],
        data: { ...item,
          copy_markIcon: this.init_data.pointTypeBOS[this.active_mark_type].icon,
          markIcon: this.init_data.pointTypeBOS[this.active_mark_type].icon,
          markSelectIcon: this.init_data.pointTypeBOS[this.active_mark_type].iconIn
        }
      };
      this.cluster_marker_list.push(obj);
    });
  } // 当点击地图上的marker点位时


  clickMarker(context) {
    this.active_marker = context.data[0].data;
    this.audio_src = this.active_marker.audio;
    this.cluster_marker_list.forEach(item => {
      item.data.markIcon = item.data.copy_markIcon;
    });
    {
      // 此处代码是由于当更改全部marker icon后,数据不更新,只有当更改地图经纬度或者更改地图的zoom等级才会重新渲染数据;
      // 因此此处修改一下地图的center然后再修改回来,从而达到更新数据,并且不会在视觉上有任何效果
      const {
        lng,
        lat
      } = this.map.getCenter();
      this.map.setCenter([this.map.getCenter().lng - 0.00001, this.map.getCenter().lat]);
      this.map.setCenter([lng, lat]);
    }
    context.data[0].data.markIcon = context.data[0].data.markSelectIcon;
    context.marker.setContent(this.getMarkerDom(context).active_marker_content);
    this.is_show_marker_detail_modal = true;
  } // 通过点聚合渲染marker点


  async showMarker() {
    const that = this;
    this.cluster = new this.AMap.MarkerClusterer(this.map, this.cluster_marker_list, {
      gridSize: 30,
      renderMarker: function (context) {
        context.marker.setOffset(new that.AMap.Pixel(-36, -33));
        context.marker.setContent(that.getMarkerDom(context).marker_content);
        context.marker.on("click", function () {
          that.clickMarker(context);
        });
      },
      renderClusterMarker: function (context) {
        context.marker.setOffset(new that.AMap.Pixel(-36, -33));
        context.marker.setContent(that.getMarkerDom(context.clusterData[0], true, context.count).cluster_marker_content);
        context.marker.on("click", function () {
          that.map.setZoomAndCenter(that.scenic_data.maxZoom - 1, [context.clusterData[0].data.longitude, context.clusterData[0].data.latitude]);
        });
      }
    });
  } // 获取当前定位


  async getGeolocation() {
    const that = this;
    const geolocation = await new this.AMap.Geolocation({
      // 是否使用高精度定位，默认：true
      enableHighAccuracy: true,
      // 设置定位超时时间，默认：无穷大
      timeout: 10000,
      // 定位按钮的停靠位置的偏移量
      offset: [10, 20],
      //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
      zoomToAccuracy: true,
      //  定位按钮的排放位置,  RB表示右下
      position: "RB"
    });
    geolocation.getCurrentPosition((status, result) => {
      if (status == "complete") {
        onComplete(result);
      } else {
        onError(result);
      }
    });

    function onComplete(data) {
      console.log("定位成功"); // data是具体的定位信息

      sessionStorage.setItem("lng", data.position.lng);
      sessionStorage.setItem("lat", data.position.lat);

      if (!that.my_position) {
        that.my_position = new that.AMap.Marker({
          position: new that.AMap.LngLat(data.position.lng, data.position.lat),
          icon: new that.AMap.Icon({
            size: new that.AMap.Size(24, 34),
            image: require('../../static/images/my-pos.png'),
            imageSize: new that.AMap.Size(24, 34) // 根据所设置的大小拉伸或压缩图片

          }),
          offset: new that.AMap.Pixel(-12, -17)
        });
        that.map.add(that.my_position);
      } else {
        that.my_position.setPosition([data.position.lng, data.position.lat]);
      }
    }

    function onError(data) {
      console.log("定位失败"); // 定位出错

      console.log(data);
    }
  }

  async mounted() {
    this.scenic_data = JSON.parse(sessionStorage.getItem("scenic_data"));

    if (!this.scenic_data) {
      this.$router.push("/");
    }

    await this.initMap();
    await this.getGeolocation();
    const lng = localStorage.getItem("lng") || this.map.getCenter().lng;
    const lat = localStorage.getItem("lat") || this.map.getCenter().lat;
    const res = await initScenicData(this.scenic_data?.id, lng, lat);
    this.init_data = res.data;
    const haveDetailList = this.init_data.pointTypeBOS.filter(item => {
      if (item.isDetails) {
        return item?.id;
      }
    });
    this.init_data.pointBOS.forEach(item => {
      if (haveDetailList.indexOf(item.pointTypeId)) {
        item.is_detail = 1;
      } else {
        item.is_detail = 0;
      }
    });
    const point_id = +sessionStorage.getItem("point_id");

    if (point_id) {
      this.active_mark_type = this.init_data.pointTypeBOS.findIndex(item => {
        return +sessionStorage.getItem("pointTypeId") === item?.id;
      });
      this.getClusterMarkerList();

      if (this.cluster_marker_list.length) {
        this.active_marker = this.cluster_marker_list.filter(item => {
          return item?.data?.id == point_id;
        })[0].data;
      }

      if (this.active_marker) {
        this.is_show_marker_detail_modal = true;
        this.map.setZoomAndCenter(this.scenic_data.maxZoom, [this.active_marker.longitude, this.active_marker.latitude]);
      } else {
        sessionStorage.removeItem("point_id");
      }
    }

    this.getClusterMarkerList();
    await this.showMarker();
    sessionStorage.removeItem("point_id");
    sessionStorage.removeItem("pointTypeId");
    this.menu_class_name = this.class_name_list[this.scenic_data.id];
    this.menu_class_name_active = this.menu_class_name + "-active";

    if (this.$route.params.line_id) {
      this.is_show_line_detail_modal = true;
      await this.queryLineDetail(+this.$route.params.line_id);
    }

    if (localStorage.getItem('line_id')) {
      this.is_show_line_detail_modal = true;
      await this.queryLineDetail(+localStorage.getItem('line_id'));
      this.openLineScenicModal();
      localStorage.removeItem('line_id');
    }

    this.get_position = setInterval(async () => {
      await this.getGeolocation();
    }, 3000);
  }

  beforeDestory() {
    clearInterval(this.get_position);
  } // 切换顶部选型卡


  async changeMenuItem(index) {
    if (this.active_mark_type != index) {
      this.cluster_marker_list = [];
      this.cluster.setData();
      this.active_mark_type = index;
      this.getClusterMarkerList();
      await this.showMarker();
      this.is_show_marker_detail_modal = false;
      this.pauseAudio();
      this.map.setFitView();
    }
  } // 关闭景区详情模态窗


  async closeScenicDetailModal() {
    this.is_show_marker_detail_modal = false;
    this.cluster_marker_list = [];
    this.cluster.setData();
    this.getClusterMarkerList();
    await this.showMarker();
    this.pauseAudio();
  } // 获取线路详情信息


  async queryLineDetail(id) {
    const res = await queryLineDetail(id);
    this.line_detail_data = initLineDetail(res.data);
  } // 关闭开始游玩模态窗


  async closeLineScenic() {
    this.is_show_line_scenic = false;
    this.map.remove(this.line_marker);
    this.map.remove(this.polyline);
    this.getClusterMarkerList();
    await this.showMarker();
    this.pauseAudio();
  } // 跳转到高德地图页面


  jumpMap(target_lng, target_lat, name) {
    const lng = localStorage.getItem("lng");
    const lat = localStorage.getItem("lat");
    var ua = navigator.userAgent.toLowerCase();

    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      //在微信就用微信地图
      this.openLocation({
        name: name,
        latitude: target_lat,
        longitude: target_lng,
        address: '',
        scale: 12,
        infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转

      });
    } else {
      let url = 'http://uri.amap.com/navigation?from=' + lng + ',' + lat + ',我的位置&to=' + target_lng + ',' + target_lat + ',' + name + '&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0';
      window.location.href = url;
    }
  } // 预览图片


  previewImage() {
    ImagePreview(this.line_detail_data.imgList.map(item => this.base_url + item.pic));
  } // 播放音频


  playAudio() {
    const audio = this.$refs.audio;
    this.is_play = true;
    audio.play();
  } // 暂停音频


  pauseAudio() {
    const audio = this.$refs.audio;
    audio.pause();
    this.is_play = false;
  }

  findMyPosition() {
    const lng = sessionStorage.getItem("lng");
    const lat = sessionStorage.getItem("lat");

    if (lng && lat) {
      this.map.setCenter([lng, lat]);
    }
  } // 打开开始游玩模态窗


  openLineScenicModal() {
    this.is_show_line_scenic = true;
    this.is_show_line_detail_modal = false;
    this.cluster_marker_list = [];
    this.cluster.setData();
    this.createdLinePointMarker();
    this.audio_src = this.line_detail_data.points[this.active_point].audio;
  } // 渲染路线详情中景点的marker


  createdLinePointMarker() {
    const color = this.themeColor[this.scenic_data.id];
    const that = this; // 生成路线详情下的marker点

    this.line_detail_data.points.forEach((item, index) => {
      var markerContent = `<div class="marker-style-normal">
            <img src='${this.base_url}${this.active_point === index ? item.iconIn : item.icon}'/>
            <span color: ${this.active_point === index ? "white" : color}">${index + 1}</span>
            <div style="color: ${color}">${item.name}</div>
          </div>`;
      var marker = new this.AMap.Marker({
        position: new this.AMap.LngLat(item.longitude, item.latitude),
        content: markerContent,
        offset: new this.AMap.Pixel(-36, -37),
        extData: { ...item
        }
      });
      marker.on("click", function () {
        that.active_point = index;
        that.line_marker.forEach((item, index) => {
          item.setContent(`<div class="marker-style-normal">
            <img  src='${that.base_url}${item._opts.extData.icon}'/>
            <span color: ${color}">${index + 1}</span>
            <div style="color: ${color}">${item._opts.extData.name}</div>
          </div>`);
        });
        marker.setContent(`<div class="marker-style-normal">
            <img src='${that.base_url}${that.active_point === index ? item.iconIn : item.icon}'/>
            <span>${index + 1}</span>
            <div style="color: ${color}">${item.name}</div>
          </div>`);
      });
      this.line_marker.push(marker);
    });
    this.map.add(this.line_marker);
    this.polyline = new this.AMap.Polyline({
      path: this.line_detail_data.points.map(item => [item.longitude, item.latitude]),
      isOutline: true,
      outlineColor: "#fff",
      borderWeight: 2,
      strokeColor: "#4A93FF",
      strokeOpacity: 1,
      strokeWeight: 6,
      strokeStyle: "solid",
      // strokeStyle是dashed时有效
      strokeDasharray: [10, 5],
      lineJoin: "round",
      lineCap: "round",
      zIndex: 50
    });
    this.map.add(this.polyline);
    this.map.setFitView();
  } // 点击列表按钮


  clickListBtn() {
    const listModal = this.$refs["list-modal"];
    listModal.is_show = false;
  } // 获取到点击的点位


  getClickItem(item) {
    this.cluster_marker_list = [];
    this.cluster.setData();
    this.getClusterMarkerList();
    this.cluster_marker_list.forEach(mareker_item => {
      if (item.data.id === mareker_item.data.id) {
        mareker_item.data.markIcon = mareker_item.data.markSelectIcon;
      }
    });
    this.showMarker();
    this.map.setZoomAndCenter(this.scenic_data.maxZoom, [item.data.longitude, item.data.latitude]);
    const listModal = this.$refs["list-modal"];
    listModal.is_show = true;
    this.active_marker = item.data;
    this.is_show_marker_detail_modal = true;
  } // 跳转到路线列表页面


  goLineListPage() {
    this.is_show_marker_detail_modal = false;
    this.$router.push({
      path: "/line-list",
      query: { ...this.$route.query
      }
    });
  } // 返回首页


  goIndex() {
    this.$router.push("/");
  }

  touchstart(e) {
    this.start_y = e.touches[0].clientY;
  }

  touchmove(e) {
    this.move_y = e.touches[0].clientY;

    if (this.start_y - this.move_y >= 100) {
      // 右滑触发
      // do something
      this.line_detail_modal_class_name = "ling-detail-modal-fullview";
    }
  } // 关闭路线详情模态窗全屏


  cancelFullView() {
    if (this.line_detail_modal_class_name) {
      this.line_detail_modal_class_name = "";
    } else {
      this.is_show_line_detail_modal = false;
    }
  } // 跳转到景点详情页面


  jumpScenicDetail(id) {
    if (this.line_detail_data.id) {
      localStorage.setItem('line_id', this.line_detail_data.id + '');
    }

    this.$router.push({
      path: "/scenic-detail",
      query: {
        id
      }
    });
  } // 开始游玩模态窗内点击下个景点按钮


  nextScenic() {
    if (this.active_point < this.line_detail_data.points.length - 1) {
      this.active_point++;
      this.audio_src = this.line_detail_data.points[this.active_point].audio;
      this.changeMarker();
      this.pauseAudio();
    }
  } // 开始游玩模态窗内点击上个景点按钮


  prevScenic() {
    if (this.active_point > 0) {
      this.active_point--;
      this.audio_src = this.line_detail_data.points[this.active_point].audio;
      this.pauseAudio();
      this.changeMarker();
    }
  } // 通过左右按钮切换景点时设置marker点样式


  changeMarker() {
    this.line_marker.forEach((item, index) => {
      item.setContent(`<div class="marker-style-normal">
            <img src='${this.base_url}${item._opts.extData.icon}'/>
            <span>${index + 1}</span>
            <div>${item._opts.extData.name}</div>
          </div>`);
    });
    this.line_marker[this.active_point].setContent(`<div class="marker-style-normal">
            <img  src='${this.base_url}${this.line_marker[this.active_point]._opts.extData.iconIn}'/>
            <span >${this.active_point + 1}</span>
            <div>${this.line_marker[this.active_point]._opts.extData.name}</div>
          </div>`);
  }

};
ScenicPage = __decorate([Component({
  name: 'scenic',
  components: {
    ListModal
  }
})], ScenicPage);
export default ScenicPage;